import Vue from 'vue'
import Vuex from 'vuex'
import GenericError from '@/store/modules/GenericError'
import Countries from '../plugins/factory/Countries'
import Timezones from '../plugins/factory/Timezones'

Vue.use(Vuex)
/* eslint-disable */
const lang = () => {
  let lang = window.navigator.language
  if (lang.indexOf('-') > -1) {
    lang = lang.split('-')[0]
  }
  return lang
}

export default new Vuex.Store({
  state: {
    hamburgerMenuState: {
      open: false,
      close: false
    },
    currentLanguage: lang(),
    currentTimezone: lang(),
    organizations: {},
    user: {
      userInfo: null,
      isAdmin: false,
      isAuth: false
    },
    userSecurityQuestions: [],
    securityQuestions: [],
    locationDeviseData: [],
    loading: true,
    graphLoading: true,
    items_per_page: 10,
    items_per_page_status: 10,
    items_per_page_dashboard: 10,
    selectedAsset: 'ALL',
    selectedAssetTypeStatus: 'ALL',
    assets: [],
    statusDetails: [],
    locations: [],
    selectedLocation: 'ALL',
    assetHistory: [],
    selectedBeaconID: null,
    selectedAssetID: null,
    pairingList: [],
    selectedHistoryAssetID: '',
    selectedStatusAssetID: '',
    selectedHistoryDeviceID: '',
    selectedStatusDeviceID: '',
    profileUpdatedFlage : false,
    pwdChangeHistory: [],
    securityOrgdProfiles: [],
    passwordPolicies: '',
    authPolicy: '',
    personsData: [],
    personRoles: [],
    personAllRoles: [],
    detailPerson: {},
    directorytabsflag: false,
    newPwd: '',
    password: {},
    selectedHomeLocation: 'ALL',
    selectedDashboardHomeLocation: 'ALL',
    selectedPairingHomeLocation: 'ALL',
    homelocationlist: [],
    statusGraphData: [],
    pwdRules: [],
    internalStatusList: [],
    selectedInternalStatus: [],
    commentsAssetList: [],
    assetCommentsHistory: []
  },
  actions: {
    clearUserData ({commit}) {
      commit('CLEAR_USER_DATA')
    },
    setHamburgerMenuOpenState ({commit}, result) {
      commit('SET_HamburgerMenu_OpenState', result)
    },
    setHamburgerMenuCloseState ({commit}, result) {
      commit('SET_HamburgerMenu_CloseState', result)
    },
    setUserInfo ({commit}, result) {
      commit('SET_USER_INFO', result)
    },
    setUserPendingApps ({commit}, result) {
      commit('SET_USER_PENDING_APPS', result)
    },
    setUserAppDetails ({commit}, result1, result2, result3, result4, result5) {
      commit('SET_USER_APPS_Details', result1, result2, result3, result4, result5)
    },
    userLoggedIn ({commit}, result) {
      commit('USER_LOGGED_IN', result)
    },
    adminLoggedIn ({commit}, result) {
      commit('ADMIN_LOGGED_IN', result)
    },
    setCurrentLanguage ({commit}, result) {
      commit('SET_CURRENT_LANGUAGE', result)
    },
    setCurrentTimezone ({commit}, result) {
      commit('SET_CURRENT_Timezone', result)
    },
    setOrganizations ({commit}, result) {
      commit('SET_ORGANIZATIONS', result)
    },
    getPasswordPolicySecured ({state, commit}) {
      Vue.prototype.$API.getPasswordPolicySecured({ policyId: state.user.userInfo.organization.passwordPolicy.id }).then(res => {
        commit('SET_PASSWORD_RULES', res.rules)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getOrganizationWithAttributes({state, commit}, organizationId) {
      Vue.prototype.$API.getOrganizationWithAttributes({ organizationId: organizationId })
        .then((res) => {
          return res;
        }).then((res) => {
          Vue.prototype.$API.getPasswordPolicySecured({ policyId: res.passwordPolicy.id }).then(resp => {
            commit('SET_PASSWORD_RULES', resp.rules)
          }).catch(err => {
            console.log('There was an error in fetcting user\'s granted applications ' + err)
          })
        }).catch(err => {
          console.log('There was an error in fetcting user\'s granted applications ' + err)
        })
    },
    getUserSecurityQuestions ({state, commit, dispatch}) {
      Vue.prototype.$API.getSecurityQuestionAccount({ personId: state.user.userInfo.user.id }).then(res => {
        const questions = res.questions ? res.questions : []
        commit('SET_USER_SECURITY_QUESTIONS', questions)
      }).catch(err => {
        dispatch('clearUserData')
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    updateUserSecurityQuestionAccount ({commit, dispatch}, payload) {
      Vue.prototype.$API.updateSecurityQuestionAccount({personId: payload.id, data: payload}).then(res => {
        dispatch('getUserSecurityQuestions')
        commit('SET_PROFILE_UPDATED_FLAG', true)
      }).catch(err => {
        //dispatch('clearUserData')
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getSecurityQuestions ({commit, dispatch}) {
      Vue.prototype.$API.getSecurityQuestions().then(res => {
        commit('SET_SECURITY_QUESTIONS', res)
      }).catch(err => {
        dispatch('clearUserData')
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getDeviceData ({state, commit, dispatch}, payload) {
      commit('SET_LOADING', true)
      if (payload.widget === 'ASSET_STATUS') {
        commit('SET_GRAPH_LOADING', true)
      }
      Vue.prototype.$API.getDeviseData({data: payload}).then(res => {
        if (payload.widget === 'ASSET_COUNT') {  // dashboard
          if(payload.assetType === 'ALL'){ // status page location dropdown 
            if(res.data.rows) {
              let loc = res.data.rows.map((item) => {
                return item.f[0].v
              }).filter(n => n !== null)
              loc.unshift('ALL')
              commit('SET_LOCATIONS', loc)
            }else {
              let loc = []
              loc.unshift('ALL')
              commit('SET_LOCATIONS', loc)
            }            
          }
          var data = res.data.rows ? res.data.rows : [];
          commit('SET_LOCATION_DEVICE_DATA', data)
        } else if (payload.widget === 'ASSET_TYPE') { // dashboard Dropdown asset type
          let assetsList = res.data.rows.map((item) => {
            return item.f[0].v
          }).filter(n => n !== null)
          assetsList.unshift('ALL')
          commit('SET_ASSETS', assetsList)
        } else if (payload.widget === 'ASSET_DETAILS') { // status page table data
          if(res.data.rows) {
            var statusResData = res.data.rows.map((item) => {
              return {
                index: item.f[0].v,
                device_id: item.f[1].v,
                asset_id: item.f[2].v,
                asset_type: item.f[5].v,
                location: item.f[4].v,
                status: item.f[3].v,
                status_date: item.f[6].v,
                BATTERY_VOLTAGE: item.f[8].v,
                count: item.f[9].v
              }
            })  
          }else {
            var statusResData = []
          }
          commit('SET_STATUS_DETIALS', statusResData)
        } else if (payload.widget === 'ASSET_HISTORY') { // history page table data
          if(res.data.rows) {
            var historyResData = res.data.rows.map((item) => {
              return {
                index: item.f[0].v,
                device_id: item.f[1].v,
                asset_id: item.f[3].v,
                asset_type: item.f[6].v,
                location: item.f[5].v,
                status: item.f[4].v,
                status_date: item.f[2].v,
                BATTERY_VOLTAGE: item.f[9].v,
                count: item.f[10].v,
              }
            })  
          }else {
            var historyResData = []
          }
          commit('SET_HISTORY', historyResData)
        } else if (payload.widget === 'GET_ASSET_PAIRING_DATA') { // Pairing page get action
          if(res.data.rows) {
            var pairingData = res.data.rows.map((item) => {
              return {
                asset_id: item.f[2].v,
                beacon_id: item.f[0].v,
                location: item.f[1].v,
                ASSET_OWNER: item.f[3].v
              }
            })  
          }else {
            var pairingData = []
          }
          commit('SET_PAIRING_DATA', pairingData)
        } else if (payload.widget === 'ASSET_COMMENTS_LIST') { // Asset Comments
          if(res.data.rows) {
            var assetComments = res.data.rows.map((item) => {
              return {
                asset_id: item.f[1].v,
                modified_by: item.f[4].v,
                status_date: item.f[2].v,
                count: item.f[5].v,
                internal_status: item.f[3].v
              }
            });
          }else {
            var assetComments = [];
          }
          commit('SET_ASSET_COMMENTS_LIST', assetComments)
        } else if (payload.widget === 'ASSET_COMMENTS_HISTORY') { // Asset Comments History
          if(res.data.rows) {
            var commentsHistory = res.data.rows.map((item) => {
              return {
                asset_id: item.f[1].v,
                modified_by: item.f[4].v,
                status_date: item.f[2].v,
                count: item.f[5].v,
                internal_status: item.f[3].v
              }
            });
          }else {
            var commentsHistory = [];
          }
          commit('SET_ASSET_COMMENTS_HISTORY', commentsHistory)
         } else if (payload.widget === 'INTERNAL-STATUS_LIST') { // internal status dropdown list
            if(res.data.rows) {
              var dataList = res.data.rows.map((item) => {
                 return item.f[0].v.split(",").map((element) => element.trim());
              });
              dataList = dataList[0];
            } else {
               var dataList = [];
            }
            commit('SET_INTERNAL_STATUS_LIST', dataList);
        } else if (payload.widget === 'POST_ASSET_PAIRING_DATA') { //pairing data update or create action
          console.log('pairing data create or update', res.data)
          var payloadForGetPairing;
          if (state.user.userInfo.organization.attributes.find(item=> item.name == 'homeLocation').value == 'TLO') {
            payloadForGetPairing = {"widget": "GET_ASSET_PAIRING_DATA", userOrgHomeLocation: 'ALL'}
          } else {
            payloadForGetPairing = {"widget": "GET_ASSET_PAIRING_DATA", userOrgHomeLocation: state.selectedPairingHomeLocation}
          }
          dispatch('getDeviceData', payloadForGetPairing)
        } else if (payload.widget === 'ASSET_STATUS') { // status graphs data
          if(res.data.rows) {
            var graphData = res.data.rows.map((item) => {
              return {  status : item.f[0].v,
                list: [
                {count: parseInt(item.f[1].v), genre: "Type A"},
                {count: parseInt(item.f[2].v), genre: "Type B"},
                {count: parseInt(item.f[3].v), genre: "Type C"},
              ]
              }
            })
          } else {
            var graphData = [];
          }
          commit('SET_STATUS_GRAPH', graphData)          
          setTimeout(function(){ commit('SET_GRAPH_LOADING', false); }, 1000);
        }
        commit('SET_LOADING', false)
      }).catch(err => {
        commit('SET_LOADING', false)
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    updateItemsPerPage ({commit}, perPage) {
      commit('SET_ITEMS_PER_PAGE', perPage)
    },
    updateStatusItemsPerPage ({commit}, perPage) {
      commit('SET_ITEMS_PER_PAGE_STATUS', perPage)
    },
    updateDashboardItemsPerPage ({commit}, perPage) {
      commit('SET_ITEMS_PER_PAGE_DASHBOARD', perPage)
    },
    updateSelectedAsset ({commit}, asset) {
      commit('SET_SELECTED_ASSET', asset)
    },
    updateSelectedLocation ({commit}, loc) {
      commit('SET_SELECTED_LOCATION', loc)
    },
    updateSelectedAssetID ({commit}, assetId) {
      commit('SET_SELECTED_ASSET_ID', assetId)
    },
    updateSelectedBeaconID ({commit}, beaconId) {
      commit('SET_SELECTED_Beacon_ID', beaconId)
    },
    UpdateUserProfile ({commit, dispatch, state}, payload) {
      Vue.prototype.$API.updatePerson({personId: payload.id, data: payload.user}).then(res => { 
        if(state.user.userInfo.user.id == payload.id) {
          commit('SET_USER_DETAILS', res)
        } else {
          commit('SET_PERSON', res)
        }
        dispatch('getPersonsData', {pageSize: 200, orgId: state.user.userInfo.organization.id, "organization.id": state.user.userInfo.organization.id['id']})
        commit('SET_PROFILE_UPDATED_FLAG', true)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    updateUserPassword ({commit}, payload) {
      Vue.prototype.$API.updatePersonPassword({personId: payload.id, data: payload.pwdParams}).then(res => { 
        commit('SET_PROFILE_UPDATED_FLAG', true)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPasswordChangeHistory ({commit}, id) {
      Vue.prototype.$API.getPasswordChangeHistory({personId: id}).then(res => { 
        commit('SET_PASSWORD_CHANGE_HISTORY', res)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getSecurityOrgProfiles ({commit, state}) {
      Vue.prototype.$API.getOrganizationSecurityAdmins({organizationId: state.user.userInfo.organization.id}).then(res => { 
        commit('SET_SECURITY_ORG_PROFILES', res)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPasswordPolicies ({commit, state}) {
      Vue.prototype.$API.getPasswordPolicy({policyId: state.user.userInfo.organization['passwordPolicy']['id']}).then(res => {
        commit('SET_PASSWORD_POLICIES', res.name)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getAuthPolicy ({commit, state}) {
      Vue.prototype.$API.getAuthenticationPolicy({policyId: state.user.userInfo.organization['authenticationPolicy']['id']}).then(res => {
        commit('SET_AUTH_PASSWORD_POLICY', res.name)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPersonsData ({commit}, payload) {
      Vue.prototype.$API.getPersons({data: payload}).then(res => {
        commit('SET_PERSONS_DATA', res)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPersonRoles ({commit, dispatch}, roleId) {
      Vue.prototype.$API.getPersonRolesOnly({personId: roleId}).then(res => {
        commit('SET_PERSON_ROLES', res)
        dispatch('getPersonAllRoles', roleId)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPersonAllRoles ({commit, state}, roleId) {
      Vue.prototype.$API.getPersonRolesGrantable({personId: roleId}).then(res => {
        let grantList = res.filter(o1 => !state.personRoles.some(o2 => o1.name === o2.name));
        let availableList = grantList.filter(function(item) {
          if(["Security Administrator", "Maintenance User", "Materials Manager"].includes(item.name)){
            return item
         }
        })        
        console.log('availableList', availableList)
        commit('SET_PERSON_ALL_ROLES', availableList)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPerson ({commit}, personId) {
      Vue.prototype.$API.getPerson({personId: personId}).then(res => {
        commit('SET_PERSON', res)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    suspendPerson ({commit, dispatch,state}, payload) {
      commit('SET_DIRECTOY_FLAG', false)
      console.log('payload', payload)
      Vue.prototype.$API.suspendPerson({qs: payload}).then(res => {
        dispatch('getPerson', payload[0][1])
        dispatch('getPersonsData', {pageSize: 200, orgId: state.user.userInfo.organization.id, "organization.id": state.user.userInfo.organization.id['id']})
        commit('SET_DIRECTOY_FLAG', true)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    unsuspendPerson ({commit, dispatch, state}, payload) {
      commit('SET_DIRECTOY_FLAG', false)
      console.log('payload', payload)
      Vue.prototype.$API.unsuspendPerson({qs: payload}).then(res => {
        dispatch('getPerson', payload[0][1])
        dispatch('getPersonsData', {pageSize: 200, orgId: state.user.userInfo.organization.id, "organization.id": state.user.userInfo.organization.id['id']})
        commit('SET_DIRECTOY_FLAG', true)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    removePerson ({commit, dispatch, state}, payload) {
      commit('SET_DIRECTOY_FLAG', false)
      console.log('payload', payload)
      Vue.prototype.$API.removePerson({personId:payload.personId, qs: payload.reason}).then(res => {
        dispatch('getPerson', payload.personId)
        dispatch('getPersonsData', {pageSize: 200, orgId: state.user.userInfo.organization.id, "organization.id": state.user.userInfo.organization.id['id']})
        commit('SET_DIRECTOY_FLAG', true)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    updatePersonPassword({commit, dispatch}, payload) {
      commit('SET_DIRECTOY_FLAG', false)
      Vue.prototype.$API.specifyPersonPassword({data: payload.updateInfo}).then(res => {
        commit('SET_DIRECTOY_FLAG', true)
        dispatch('expirePersonPassword', payload)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    resetPersonPassword ({commit}, personID) {
      Vue.prototype.$API.resetPersonPassword({qs: [['subject', personID]]}).then(res => {
        commit('SET_RESET_PASSWORD', res.password)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPersonPassword({dispatch}, payload) {
      Vue.prototype.$API.getPersonPassword({personId: payload.subject}).then(res => {
        dispatch('updatePersonPassword', {updateInfo: payload, pwdInfo: res})
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    getPersonPasswordOnly({commit}, id) {
      Vue.prototype.$API.getPersonPassword({personId: id}).then(res => {
        commit('SET_PASSWORD', res)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    expirePersonPassword({}, payload) {
      Vue.prototype.$API.expirePersonPassword({qs: [['subject', payload.updateInfo.subject]], data: {"subject": payload.updateInfo.subject, "password": payload.updateInfo.password, "passwordPolicyId": payload.pwdInfo.passwordPolicy.id, "authenticationPolicyId": payload.pwdInfo.authenticationPolicy.id}}).then(res => {
        commit('SET_RESET_PASSWORD', res.password)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    removePersonRoles ({dispatch}, payload) {
      Vue.prototype.$API.removePersonRoles({data: payload}).then(res => {
        dispatch('getPersonRoles', payload.userId)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    },
    assignPersonRoles ({dispatch}, payload) {
      Vue.prototype.$API.assignPersonRoles({data: payload}).then(res => {
        dispatch('getPersonRoles', payload.userId)
      }).catch(err => {
        console.log('There was an error in fetcting user\'s granted applications ' + err)
      })
    }
  },
  mutations: {
    CLEAR_USER_DATA (state) {
      state.user.userInfo = null
    },
    SET_HamburgerMenu_OpenState (state, result) {
      state.hamburgerMenuState.open = result
    },
    SET_HamburgerMenu_CloseState (state, result) {
      state.hamburgerMenuState.close = result
    },
    SET_USER_INFO (state, result) {
      state.user.userInfo = result
    },
    SET_TIMEZONE_USER_INFO (state, timezone) {
      state.user.userInfo.user.timezone = timezone
    },
    SET_USER_DETAILS (state, result) {
      state.user.userInfo.user = result
    },
    SET_USER_PENDING_APPS (state, result) {
      state.user.userInfo.pendingApps = result
    },
    SET_USER_APPS_Details (state, result1, result2, result3, result4, result5) {
      state.user.userInfo.userAppRequestsCount = result1
      state.user.userInfo.userRegistrationRequestsCount = result2
      state.user.userInfo.orgRegistrationRequestsCount = result3
      state.user.userInfo.orgAppRequestsCount = result4
      state.user.userInfo.totalCount = result5
    },
    USER_LOGGED_IN (state, result) {
      state.user.isAuth = result
    },
    ADMIN_LOGGED_IN (state, result) {
      state.user.isAdmin = result
    },
    SET_CURRENT_LANGUAGE (state, result) {
      state.currentLanguage = result
      Countries.setCountries(result)
    },
    SET_CURRENT_Timezone (state, result) {
      state.currentTimezone = result
      Timezones.setTimezones(result)
    },
    SET_ORGANIZATIONS (state, result) {
      state.organizations = result
    },
    SET_USER_SECURITY_QUESTIONS (state, questions) {
      state.userSecurityQuestions = questions
    },
    SET_SECURITY_QUESTIONS (state, questions) {
      state.securityQuestions = questions
    },
    SET_LOCATION_DEVICE_DATA (state, deviseData) {
      state.locationDeviseData = deviseData
    },
    SET_LOADING (state, flag) {
      state.loading = flag
    },
    SET_GRAPH_LOADING (state, flag) {
      state.graphLoading = flag
    },
    SET_ITEMS_PER_PAGE (state, itemsPage) {
      state.items_per_page = itemsPage
    },
    SET_ITEMS_PER_PAGE_STATUS (state, itemsPage) {
      state.items_per_page_status = itemsPage
    },
    SET_ITEMS_PER_PAGE_DASHBOARD (state, itemsPage) {
      state.items_per_page_dashboard = itemsPage
    },
    SET_SELECTED_ASSET (state, asset) {
      state.selectedAsset = asset
    },
    SET_SELECTED_ASSET_TYPE_STATUS (state, asset) {
      state.selectedAssetTypeStatus = asset
    },
    SET_ASSETS (state, assets) {
      state.assets = assets
    },
    SET_STATUS_DETIALS (state, statusInfo) {
      state.statusDetails = statusInfo
    },
    SET_LOCATIONS (state, locs) {
      state.locations = locs
    },
    SET_SELECTED_LOCATION (state, loc) {
      state.selectedLocation = loc
    },
    SET_HISTORY (state, history) {
      state.assetHistory = history
    },
    SET_PAIRING_DATA (state, list) {
      state.pairingList = list
    },
    SET_ASSET_COMMENTS_LIST (state, list) {
      state.commentsAssetList = list
    },
    SET_ASSET_COMMENTS_HISTORY (state, list) {
      state.assetCommentsHistory = list
    },
    SET_SELECTED_ASSET_ID (state, asset) {
      state.selectedAssetID = asset
    },
    SET_SELECTED_Beacon_ID (state, beacon) {
      state.selectedBeaconID = beacon
    },
    SET_SELECTED_HISTORY_ASSET_ID (state, assetId) {
      state.selectedHistoryAssetID = assetId
    },
    SET_SELECTED_STATUS_ASSET_ID (state, assetId) {
      state.selectedStatusAssetID = assetId
    },
    SET_PROFILE_UPDATED_FLAG (state, flag) {
      state.profileUpdatedFlage = flag
    },
    SET_PASSWORD_CHANGE_HISTORY (state, history) {
      state.pwdChangeHistory = history
    },
    SET_SECURITY_ORG_PROFILES (state, profiles) {
      state.securityOrgdProfiles = profiles
    },
    SET_PASSWORD_POLICIES (state, policies) {
      state.passwordPolicies = policies
    },
    SET_AUTH_PASSWORD_POLICY (state, policy) {
      state.authPolicy = policy
    },
    SET_PERSONS_DATA (state, persons) {
      state.personsData = persons
    },
    SET_PERSON_ROLES (state,roles) {
      state.personRoles = roles
    },
    SET_PERSON_ALL_ROLES (state,roles) {
      state.personAllRoles = roles
    },
    SET_PERSON (state, person) {
      state.detailPerson = person
    },
    SET_DIRECTOY_FLAG (state, flag) {
      state.directorytabsflag = flag
    },
    SET_RESET_PASSWORD (state, newPassword) {
      state.newPwd = newPassword
    },
    SET_PASSWORD (state, passwordInfo){
      state.password = passwordInfo
    },
    SET_SELECTED_HOME_LOCATION (state, selectedHomeLocation){
      state.selectedHomeLocation = selectedHomeLocation
    },
    SET_SELECTED_DASHBOARD_HOME_LOCATION (state, selectedDashboardHomeLocation){
      state.selectedDashboardHomeLocation = selectedDashboardHomeLocation
    },
    SET_SELECTED_PAIRING_HOME_LOCATION (state, selectedPairingHomeLocation){
      state.selectedPairingHomeLocation = selectedPairingHomeLocation
    },
    SET_HOME_LOCATION_LIST (state, list) {
      state.homelocationlist = list
    },
    SET_STATUS_GRAPH (state, graphData) {
      state.statusGraphData = graphData
    },
    SET_SELECTED_HISTORY_DEVICE_ID (state, selectedHistoryDeviceID){
      state.selectedHistoryDeviceID = selectedHistoryDeviceID
    },
    SET_SELECTED_STATUS_DEVICE_ID (state, selectedStatusDeviceID){
      state.selectedStatusDeviceID = selectedStatusDeviceID
    },    
    SET_PASSWORD_RULES (state, pwdRules){
      state.pwdRules = pwdRules
    },
    SET_INTERNAL_STATUS_LIST (state, list) {
      state.internalStatusList = list
    },
    SET_SELECTED_ASSET_INTERNAL_STATUS (state, selectedInternalStatus){
      state.selectedInternalStatus = selectedInternalStatus
    },
  },
  getters: {
    getHamburgerMenuOpenState (state) {
      return state.hamburgerMenuState.open
    },
    getHamburgerMenuCloseState (state) {
      return state.hamburgerMenuState.close
    },
    getUserInfo (state) {
      return state.user.userInfo
    },
    isAdmin (state) {
      return state.user.isAdmin
    },
    isAuth (state) {
      return state.user.isAuth
    },
    getCurrentLanguage (state) {
      return state.currentLanguage
    },
    getCurrentTimezone (state) {
      return state.currentTimezone
    },
    getOrganizations (state) {
      return state.organizations
    },
    getUserSecurityQuestions (state) {
      return state.userSecurityQuestions
    },
    getSecurityQuestions (state) {
      return state.securityQuestions
    },
    getLocationDeviseData (state) {
      return state.locationDeviseData
    },
    getLoading (state) {
      return state.loading
    },
    getGraphLoading (state) {
      return state.graphLoading
    },
    getItemsPerPage (state) {
      return state.items_per_page
    },
    getStatusItemsPerPage (state) {
      return state.items_per_page_status
    },
    getDashboardItemsPerPage (state) {
      return state.items_per_page_dashboard
    },
    getSelectedAsset (state) {
      return state.selectedAsset
    },
    getSelectedAssetTypeStatus (state) {
      return state.selectedAssetTypeStatus
    },
    getAssets (state) {
      return state.assets
    },
    getStatusDetails (state) {
      return state.statusDetails
    },
    getLocations (state) {
      return state.locations
    },
    getSelectedLocation (state) {
      return state.selectedLocation
    },
    getAssetHistory (state) {
      return state.assetHistory
    },
    getPairingList (state) {
      return state.pairingList
    },
    getCommentsAssetList (state) {
      return state.commentsAssetList
    },
    getAssetCommentsHistory (state) {
      return state.assetCommentsHistory
    },
    getAssetID (state) {
      return state.selectedAssetID
    },
    getBeaconID (state) {
      return state.selectedBeaconID
    },
    getSelectedHistoryAssetID (state) {
      return state.selectedHistoryAssetID
    },
    getSelectedStatusAssetID (state) {
      return state.selectedStatusAssetID
    },
    getProfileUpdatedFlage (state) {
      return state.profileUpdatedFlage
    },
    getPwdChangeHistory (state) {
      return state.pwdChangeHistory
    },
    getSecurityOrgProfiles (state) {
      return state.securityOrgdProfiles
    },
    getPasswordPolicies (state) {
      return state.passwordPolicies
    },
    getAuthPolicy (state) {
      return state.authPolicy
    },
    getPersonsData (state) {
      return state.personsData
    },
    getPersonRoles (state) {
      return state.personRoles
    },
    getPersonAllRoles (state) {
      return state.personAllRoles
    },
    getDetailsPerson (state) {
      return state.detailPerson
    },
    getDirectoryFlag (state) {
      return state.directorytabsflag
    },
    getNewPwd (state) {
      return state.newPwd;
    },
    getPassword (state) {
      return state.password;
    },
    getSelectedHomeLocation (state) {
      return state.selectedHomeLocation;
    },
    getSelectedDashboardHomeLocation (state) {
      return state.selectedDashboardHomeLocation;
    },
    getSelectedPairingHomeLocation (state) {
      return state.selectedPairingHomeLocation;
    },
    getHomeLocationList (state) {
      return state.homelocationlist;
    },
    getStatusGraphData (state) {
      return state.statusGraphData;
    },
    getSelectedHistoryDeviceID (state) {
      return state.selectedHistoryDeviceID;
    },
    getSelectedStatusDeviceID (state) {
      return state.selectedStatusDeviceID;
    },    
    getPwdRules(state) {
      return state.pwdRules;
    },
    getInternalStatusList (state) {
      return state.internalStatusList;
    },
    getSelectedInternalStatus (state) {
      return state.selectedInternalStatus;
    },
  },
  modules: {
    GenericError
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js